<template lang="html">
  <Datepicker
    :value="value"
    @selected="(date) => $emit('selected', date)"
    :disabled-dates="disableDates"
  />
</template>

<script>

import Datepicker from 'vuejs-datepicker';

export default {
  components: { Datepicker },
  props: ['currentDate', 'allowPastDate'],
  computed: {
    value() {
      return this.currentDate ? new Date(this.currentDate) : new Date();
    },
    disableDates() {
      if(this.allowPastDate) {
        return {};
      } else {
        return {
          to: new Date()
        };
      }
    }
  }
}
</script>

<style media="scss">
  .vdp-datepicker__calendar .cell.day {
    max-width: none;
    min-width: auto;
  }
</style>
